import { useState } from 'react'

const useModal = (initialState: boolean = false) => {
  const [isOpen, setIsOpen] = useState(initialState)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)
  const toggle = (value?: boolean) =>
    setIsOpen(typeof value === 'boolean' ? value : (prev) => !prev)

  return { isOpen, open, close, toggle }
}
export default useModal
